import { h, Fragment } from "preact";
import { useState } from "preact/hooks";
import { DatePicker, Input, Form, Button, Col, Table } from "antd";
import { getDefaultStateParams } from '../Transactions/TransactionsUtils'
import ReportsDataSource from "./ReportsDataSource";

export default function ReportsSection() {

    const { queryParams, paginationParams } = getDefaultStateParams();

    const initialState = {
        dateFrom: queryParams.defaultDateFrom.unix(),
        dateTo: queryParams.defaultDateTo.unix(),
        serviceName: queryParams.defaultServiceName,
        recordsPerPage: paginationParams.defaultPageSize,
        pageNumber: paginationParams.initialPageIndex
    }

    const [currentState, setCurrentState] = useState(initialState);

    const disabledDateRange = (current) => current > queryParams.defaultDateTo;

    const onDateRangeChange = ([selectedDateFrom, selectedDateTo]) => {

        if (!selectedDateFrom || !selectedDateTo) return;

        const dateFrom = selectedDateFrom.startOf("day").unix();
        const dateTo = selectedDateTo.endOf("day").unix();

        setCurrentState({ ...currentState, dateFrom, dateTo });
    }

    const table = ReportsDataSource().asTableView()

    return (
        <>
            <Form
                className="report__form"
                name="report"
                initialValues={{ remember: true }}
                onFinish={() => { }}
                onFinishFailed={() => { }}
                layout="inline"
                autoComplete="off"
                style={{ marginBottom: 27 }}
            >
                <Col flex={1}>
                    <Form.Item>
                        <Input 
                            placeholder={"Person ID"}
                        />
                    </Form.Item>
                </Col>
                <Col flex="none">
                    <Form.Item>
                        <DatePicker.RangePicker
                            className="report__form-picker"
                            defaultValue={[
                                queryParams.defaultDateFrom,
                                queryParams.defaultDateTo
                            ]}
                            disabledDate={disabledDateRange}
                            onCalendarChange={onDateRangeChange}
                        />
                    </Form.Item>
                </Col>
                <Col flex="none">
                    <Button>
                        Search
                    </Button>
                </Col>
            </Form>
            <Table
                columns={table.columns}
                dataSource={table.rows}
                expandable={{
                    expandedRowRender: (record) => (
                        <p style={{ margin: 0 }}>
                            {record.description}
                        </p>
                    ),
                    rowExpandable: (record) => (
                        !!record.description
                    )
                }}
            />
        </>
    )
}
